// entities/Comment.js
import axios from 'axios';

export class Comment {
  static async listForPost(postId) {
    const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/comments/post/${postId}`);
    return data;
  }
  static async create(postId, content, token) {
    const { data } = await axios.post(
        `${process.env.REACT_APP_API_URL}/comments/post/${postId}`,
        { content },
        { headers: { 'x-auth-token': token } }
    );
    return data;
  }
}
